import React from 'react'

import FaqCategory from '@components/programmatic_blocks/faq_category'
import { withGlobalContext } from '@util/global_context'
import styles from '@components/programmatic_blocks/faqs.module.scss'

class Faqs extends React.Component {
  render() {
    const globalContext = this.props.globalContext
    const { faqCategories } = globalContext

    const categoryBlocks = faqCategories.map(category => (
      <FaqCategory
        key={category.fields.name}
        name={category.fields.name}
        faqs={category.fields.faqs}
      />
    ))

    return (
      <div className={styles.faqBlock}>
        <div>{categoryBlocks}</div>
      </div>
    )
  }
}

export default withGlobalContext(Faqs)
